export default __webpack_public_path__ + "static/media/note.4ea81fd7.png";